import { BaseViewModel } from "@iot-platform/core";
import type { Station } from "@station/domain/models/station.model";
import { StationGetSelectedUseCase } from "@station/domain/usecases/station-get-selected.usecase";
import { StationRemoveSelectedUseCase } from "@station/domain/usecases/station-remove-selected.usecase";
import { inject, injectable } from "inversify";
import { action, makeObservable, observable, runInAction } from "mobx";

@injectable()
export class CustomGraphWebPageViewmodel extends BaseViewModel {
    @observable
    selectedStations: readonly Readonly<Station>[] = [];

    @observable
    initialLoading = true;

    constructor(
        @inject(StationGetSelectedUseCase)
        private readonly stationGetSelectedUseCase: StationGetSelectedUseCase,
        @inject(StationRemoveSelectedUseCase)
        private readonly stationRemoveSelectedUseCase: StationRemoveSelectedUseCase,
    ) {
        super();
        makeObservable(this);
    }

    @action
    override didMount(): void {
        this.addSub(
            this.stationGetSelectedUseCase.execute().subscribe((stations) => {
                runInAction(() => {
                    this.selectedStations = stations;
                    this.initialLoading = false;
                });
            }),
        );
    }

    @action
    removeStation(index: number): void {
        this.stationRemoveSelectedUseCase.execute(index);
    }
}
